/* unplugin-vue-components disabled */import { render } from "./navi.vue?vue&type=template&id=85879912&scoped=true"
import script from "./navi.vue?vue&type=script&lang=js"
export * from "./navi.vue?vue&type=script&lang=js"

import "./navi.vue?vue&type=style&index=0&id=85879912&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85879912"]])

export default __exports__